<template>
  <iframe
    :src="outUrl"
    width="100%"
    height="800"
    frameborder="0"
    scrolling="auto"
    id="iframename"
    name="iframename"
  ></iframe>
</template>
<style></style>
<script>
  import { mapState } from 'vuex';
  import baseUrl from '@/common/config';
  export default {
    data() {
      return {
        loading: false,
        // html: 'http://bi.sscpcn.com/page/d27efd2ddc90944cc9ac6494/cast?provider=guanbi&ssoToken=62646d6e38552b61643248422f55525642754c4c5458584a49624b62786257674e7148326373584b6d787a75477a64674870312b686d6267564b753742696c7272395730524249554659304b4b7346574833536c39555545567334364758527730466e647052574954384a30793046706f553230506953626331344a57395a4f6f557154783870496c7935506172434949595a695447566b2f35765a552b4e304261356c46557269666c4d3d',
        // html: 'http://localhost:8888/#/masterData/cooperation'
        // html: 'http://10.1.10.239:8088/maindata/redirect/redirectMenu?menuUrl=bi.sscpcn.com/page/deb1d9580831c47baa62f97e/cast&access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOlsiYXBwIiwib2F1dGgyLXJlc291cmNlIiwid2ViIl0sInVzZXJfbmFtZSI6IuW-t-WLpC1kZXYiLCJzY29wZSI6WyJhbGwiXSwiZXhwIjoxNjAwNjczNzY0LCJhdXRob3JpdGllcyI6WyJhcHAiLCJ3ZWIiXSwianRpIjoiYjk5Y2QxYzMtZmUzNy00ZTE1LTk5NzgtOGNkZTk4YjBiYjdjIiwiY2xpZW50X2lkIjoid2ViYXBwIiwiWC1BVVRILVVzZXJJZCI6IjE1NjAifQ.nLvmQ3FRyPmk0Vs-pAVfAEh16ajSlEsFNF8tGzugfv4',
        html: '',
        show: false,
      };
    },
    computed: {
      ...mapState({
        outUrl(state) {
          let innerUrl = this.$route.path;
          console.log(innerUrl);
          if (state.outUrl.outUrlList.find((it) => it.name == innerUrl)) {
            this.show = true;
            // let outUrl = state.outUrl.outUrlList.find(it=>it.name == innerUrl).url
            let id = state.outUrl.outUrlList.find((it) => it.name == innerUrl).id;
            // const hostname = document.location.protocol  +  '//' + document.location.host
            const hostname = baseUrl;
            // let url = hostname + "/maindata/redirect/redirectMenu?menuUrl=" + outUrl + "&access_token=" + this.userInfo.access_token
            let url =
              hostname +
              '/maindata/redirect/redirectMenu?id=' +
              id +
              '&access_token=' +
              this.userInfo.access_token;

            return url;
          } else {
            this.show = false;
          }
        },
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    watch: {},
    created() {
      /* console.log(22222)
      let outUrl = "bi.sscpcn.com/page/ic32d68236a99456fbd09314/cast"
      this.outUrl = hostname + "/maindata/redirect/redirectMenu?menuUrl=" + outUrl + "&access_token=" + this.userInfo.access_token */
    },
    mounted() {},
    methods: {},
  };
</script>
